/**
 * @generated SignedSource<<d55c90d3e03f5e537d94a432e86a5330>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ChargePaymentStatus = "AUTO_CHARGE" | "CANCELED" | "FULLY_REFUNDED" | "MARKED_PAID" | "NO_CHARGES" | "PAID" | "PARTIALLY_PAID" | "PARTIALLY_REFUNDED" | "PROCESSING" | "UNKNOWN" | "UNPAID";
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
import { FragmentRefs } from "relay-runtime";
export type useJoinableSpots_Booking$data = {
  readonly paymentStatus?: ChargePaymentStatus | null | undefined;
  readonly rounds: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly paymentStatus: ChargePaymentStatus;
        readonly player: {
          readonly id: string;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly startSlot: {
    readonly agenda: {
      readonly facility: {
        readonly type: FacilityType;
      };
    };
    readonly availableCapacity?: number;
    readonly requirePlayerCounts?: boolean;
  } | null | undefined;
  readonly " $fragmentType": "useJoinableSpots_Booking";
};
export type useJoinableSpots_Booking$key = {
  readonly " $data"?: useJoinableSpots_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"useJoinableSpots_Booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentStatus",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useJoinableSpots_Booking",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/)
      ],
      "type": "StandardBooking",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoundConnection",
      "kind": "LinkedField",
      "name": "rounds",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoundEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "player",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "requirePlayerCounts",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "bookingType",
                  "value": "STANDARD"
                }
              ],
              "kind": "ScalarField",
              "name": "availableCapacity",
              "storageKey": "availableCapacity(bookingType:\"STANDARD\")"
            }
          ],
          "type": "TimeSlot",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "12f43f3c811faeeae878e75537819042";

export default node;
